import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@mui/material'

const CustomBtn = styled(Button)`
    background: ${props => props.bgc ? props.bgc : "#fff"};
    font-size: ${props=> props.fs ? props.fs : "14px"};
    border-radius: 10px;
    width:  ${props=> props.w ? props.w: "130px"};;
    font-family: ${props=> props.fm ? props.fm : "PoppinsB"};
    margin:  ${props=> props.m ? props.m : "0 5px"};
    padding:  ${props=> props.p ? props.p : "6px 16px"};
    color:${props => props.c ? props.c : "#000"};
    border: ${props => props.b ? props.b : "none"};
    transition: .5s;
    text-transform: none;
    cursor: ${props => props.cur ? props.cur : "pointer"};
    z-index: 1;
    :hover{
      color: ${props => props.hc ? props.hc : props.c};
      background: ${props => props.hbgc ? props.hbgc : props.hbgc};
      box-shadow: none;
    }
    @media(max-width:599px){
      font-size: ${props=> props.fs599 ? props.fs599 : "12px"};
  }

`

const CustomButton = (props) => {
  const {children} = props
  return (
    <CustomBtn variant='filled' {...props}>
        {children}
    </CustomBtn>
  )
}

export default CustomButton